<template>
  <div>
    <carrier-type-form v-model="carrier_type"></carrier-type-form>
  </div>
</template>
<script>
export default {
  data: function () {
    return {
      carrier_type: {
        local_attrs: [],
        global_attrs: [],
        description: '',
        carrier_code: '',
        name: '',
        required_details: '',
        list_logo: '',
        fulfillment_logo: '',
        supports_price_quoting: false,
        disable_prequote: false
      }
    };
  }
};
</script>
